import {call, put, takeEvery, select} from 'redux-saga/effects';
import * as actionTypes from './actionTypes';
import axios from 'axios';
import { getUserPageRefresh } from '../auth/sagas';

const controllerUrl = '/rules/';

const searchRulesCall = searchFields => new Promise((resolve, reject) => {
    axios.get(controllerUrl + 'search', {
        params: {
            ...searchFields,
        }
    }).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const getRuleCall = (id) => new Promise((resolve, reject) => {
    axios.get(controllerUrl + id).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const createRuleCall = (ruleData) => new Promise((resolve, reject) => {
    axios.post(controllerUrl, ruleData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const editRuleCall = (ruleId, ruleData) => new Promise((resolve, reject) => {
    axios.put(controllerUrl + ruleId, ruleData).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const deleteRuleCall = ruleId => new Promise((resolve, reject) => {
    axios.delete(controllerUrl + ruleId).then(
        response => resolve(response.data),
        error => reject(error)
    );
});

const getRuleListCall = filter => new Promise((resolve, reject) => {
    if (!axios.defaults.headers.common['Authorization']) {
        axios.get(process.env.REACT_APP_BACKEND_URL + "/auth/read-session").then(response => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + response.data;
            return axios.get(controllerUrl + 'list', {
                params: filter
            }).then(
                response => resolve(response.data),
                error => reject(error)
            );
        }).catch(e => console.log(e));
    }
    else{
        axios.get(controllerUrl + 'list', {
            params: filter
        }).then(
            response => resolve(response.data),
            error => reject(error)
        );
    }
});

function* getRuleListRequest({ filter }) {
    try {
        const userDefined = yield select(state => state.authReducer.user);

        if (!userDefined || !userDefined.role) {
            yield call(getUserPageRefresh);
        }
        const ruleList = yield call(getRuleListCall, filter);

        yield put({
            type: actionTypes.GET_RULE_LIST_SUCCESS,
            payload: ruleList.map(rule => ({value: rule.id, label: rule.name}))
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_RULE_LIST_FAILED
        });
    }
}

function* searchRulesRequest({searchFields}) {
    try {
        const searchResults = yield call(searchRulesCall, searchFields);

        yield put({
            type: actionTypes.RULE_SEARCH_SUCCESS,
            payload: searchResults
        });
    } catch (e) {
        yield put({
            type: actionTypes.RULE_SEARCH_FAILED
        });
    }
}

function* getRuleRequest({ruleId}) {
    try {
        const rule = yield call(getRuleCall, ruleId);

        yield put({
            type: actionTypes.GET_RULE_SUCCESS,
            payload: rule
        });
    } catch (e) {
        yield put({
            type: actionTypes.GET_RULE_FAILED
        })
    }
}

function* createRuleRequest({ruleData}) {
    try {
        yield call(createRuleCall, ruleData);

        yield put({
            type: actionTypes.CREATE_RULE_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.CREATE_RULE_FAILED
        })
    }
}

function* editRuleRequest({ruleId, ruleData}) {
    try {
        yield call(editRuleCall, ruleId, ruleData);

        yield put({
            type: actionTypes.EDIT_RULE_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.EDIT_RULE_FAILED
        })
    }
}

function* deleteRuleRequest({ruleId}) {
    try {
        yield call(deleteRuleCall, ruleId);

        yield put({
            type: actionTypes.DELETE_RULE_SUCCESS
        })
    } catch (e) {
        yield put({
            type: actionTypes.DELETE_RULE_FAILED
        })
    }
}

const ruleSagas = [
    takeEvery(actionTypes.GET_RULE_LIST_REQUEST, getRuleListRequest),
    takeEvery(actionTypes.RULE_SEARCH_REQUEST, searchRulesRequest),
    takeEvery(actionTypes.GET_RULE_REQUEST, getRuleRequest),
    takeEvery(actionTypes.CREATE_RULE_REQUEST, createRuleRequest),
    takeEvery(actionTypes.EDIT_RULE_REQUEST, editRuleRequest),
    takeEvery(actionTypes.DELETE_RULE_REQUEST, deleteRuleRequest),
];

export {
    ruleSagas,
    getRuleCall
};